import { pick } from "lodash-es";
import originalSupportedLanguages from "@base-impl/features/i18n/constants/supported-languages";

export default pick(originalSupportedLanguages, ['en', 'de']);